"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileIcon = void 0;
var React = __importStar(require("react"));
var icon_file_doc_svg_1 = __importDefault(require("../../assets/images/icon-file-doc.svg"));
var icon_file_docx_svg_1 = __importDefault(require("../../assets/images/icon-file-docx.svg"));
var icon_file_gif_svg_1 = __importDefault(require("../../assets/images/icon-file-gif.svg"));
var icon_file_jpg_svg_1 = __importDefault(require("../../assets/images/icon-file-jpg.svg"));
var icon_file_mov_svg_1 = __importDefault(require("../../assets/images/icon-file-mov.svg"));
var icon_file_pdf_svg_1 = __importDefault(require("../../assets/images/icon-file-pdf.svg"));
var icon_file_png_svg_1 = __importDefault(require("../../assets/images/icon-file-png.svg"));
var icon_file_ppt_svg_1 = __importDefault(require("../../assets/images/icon-file-ppt.svg"));
var icon_file_xls_svg_1 = __importDefault(require("../../assets/images/icon-file-xls.svg"));
var icon_file_xlsx_svg_1 = __importDefault(require("../../assets/images/icon-file-xlsx.svg"));
var FileIcon = /** @class */ (function (_super) {
    __extends(FileIcon, _super);
    function FileIcon(props) {
        return _super.call(this, props) || this;
    }
    FileIcon.prototype.shouldComponentUpdate = function (nextProps) {
        return this.props.type !== nextProps.type || this.props.style !== nextProps.style;
    };
    FileIcon.prototype.render = function () {
        var className = 'fileicon-' + this.props.type + (this.props.className ? ' ' + this.props.className : '');
        className = className + ' tws-i-fileicon';
        return (React.createElement(React.Fragment, null,
            React.createElement("img", { src: this.getIconType(this.props.type), style: this.props.style, className: className })));
    };
    FileIcon.prototype.getIconType = function (type) {
        switch (type) {
            case 'doc':
                return icon_file_doc_svg_1.default;
            case 'docx':
                return icon_file_docx_svg_1.default;
            case 'gif':
                return icon_file_gif_svg_1.default;
            case 'jpg':
                return icon_file_jpg_svg_1.default;
            case 'mov':
                return icon_file_mov_svg_1.default;
            case 'pdf':
                return icon_file_pdf_svg_1.default;
            case 'png':
                return icon_file_png_svg_1.default;
            case 'ppt':
                return icon_file_ppt_svg_1.default;
            case 'xls':
                return icon_file_xls_svg_1.default;
            case 'xlsx':
                return icon_file_xlsx_svg_1.default;
            default:
                return undefined;
        }
    };
    return FileIcon;
}(React.Component));
exports.FileIcon = FileIcon;
